import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { OfferKind } from "@complete-athlete/enums";

/** Packs and plans live in the offer now (ADR 0035): old links land there, on the same new one if they asked for one. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/finances/offers/")({
  validateSearch: z.object({
    create: z.enum([OfferKind.ENTRY_PACK, OfferKind.TRAINING_PLAN, OfferKind.DIET_PLAN]).optional().catch(undefined),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/offer/packs", search, replace: true });
  },
});
